/**
 * Which axis a K-09 matrix row was configured on: the agent PERSONALLY, or the agent group they
 * belonged to on the key date.
 *
 * The precedence rule is the reason this is an enum and not a boolean: an agent row beats every
 * group row of the SAME matrix chain, and it beats it across the chain — an agent row of the PARENT
 * matrix still beats a group row of the CHILD. A surface that prints this value is telling the
 * reader why one row won against another one that also matched.
 *
 * Position-based mirror of the backend enum
 * {@code com.mvs.backend.cp.enums.ProvisionConfigurationAxis}. The backend persists the ordinal
 * (`@Enumerated(EnumType.ORDINAL)`), so the declaration order below MUST match the backend exactly
 * and new constants MUST only be appended at the end — never inserted between existing ones, which
 * would silently re-map every stored value (02-datenmodell.md §0.5/§2).
 *
 * The German captions ("Persönlich", "Gruppe") live on the backend as `@UiEnumValueInfo(uiLabel =
 * …)` and reach a surface through the sibling `…Info` block of the field. Do not build a label map
 * for them here.
 */
export enum ProvisionConfigurationAxis {

    /** Ordinal 0 — "Persönlich". The row names this very agent and beats every group row. */
    AGENT,

    /** Ordinal 1 — "Gruppe". The row names the agent group the agent belonged to on the key date. */
    GROUP
}
